export var isSuccessResponse = function(response) {
    return "data" in response;
};
/**
 * Symbol used to identify API import paths, e.g. "api/v2/user/get".
 */ export var PATH = Symbol("faire.web-api.path");
